// services/EmailService.js
import { http } from './http'

class EmailService {
  constructor() {
    // e.g. http://localhost:8000/api
    this.backendUrl = process.env.VUE_APP_BACKEND_URL || 'http://localhost:8000/api'
  }

  /**
   * Envia email de contacto para o backend
   * @param {Object} payload
   * @param {string} payload.name
   * @param {string} payload.email
   * @param {string} payload.subject
   * @param {string} payload.message
   * @param {string} payload['g-recaptcha-response']  // OBRIGATÓRIO
   * @param {string} [payload.website_hp]             // honeypot (opcional)
   * @param {number} [payload.started_at]             // tempo mínimo (opcional)
   * @param {string} [overrideUrl]                    // opcional: enviar para outra URL
   */
  async sendContactEmail(payload, overrideUrl) {
    const url = (overrideUrl || this.backendUrl).replace(/\/$/, '') 

    // validações mínimas (frontend)
    const v = this.validateContactData(payload)
    if (!v.isValid) {
      throw new Error(v.errors[0])
    }
    if (!payload['g-recaptcha-response']) {
      throw new Error('Por favor, confirme o reCAPTCHA.')
    }

    // tenta via axios instance; se não houver, usa fetch
    if (http && typeof http.post === 'function') {
      try {
        const res = await http.post(url.startsWith('http') ? url : '/contact', payload, {
          timeout: 15000, // 15s
          headers: { 'Content-Type': 'application/json' },
        })

        const data = res?.data
        console.log(data)
        if (!data?.success) {
          if(data?.ok != true){
            const msg = data?.message || 'Falha no envio'
            throw new Error(msg)
          }
        }
        return {
          success: true,
          provider: data.provider || 'backend',
          messageId: data.messageId || data.id || 'sent',
          data,
        }
      } catch (err) {
        // Normaliza mensagens (HTTP/CORS/timeouts)
        if (err.response) {
          const msg = err.response.data?.message || 'Erro no servidor'
          throw new Error(`Erro ${err.response.status}: ${msg}`)
        }
        if (err.request) {
          throw new Error('Erro de rede. Verifica se o backend está ativo.')
        }
        throw err
      }
    } else {
      // Fallback fetch
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok || !data?.success) {
        throw new Error(data?.message || 'Falha no envio')
      }
      return {
        success: true,
        provider: data.provider || 'backend',
        messageId: data.messageId || data.id || 'sent',
        data,
      }
    }
  }

  /**
   * Valida os dados do contacto (frontend)
   */
  validateContactData({ name, email, subject, message }) {
    const errors = []
    if (!name || name.trim().length < 2) errors.push('Nome deve ter pelo menos 2 caracteres')
    if (!email || !this.isValidEmail(email)) errors.push('Email inválido')
    if (!subject || subject.trim().length < 3) errors.push('Assunto deve ter pelo menos 3 caracteres')
    if (!message || message.trim().length < 10) errors.push('Mensagem deve ter pelo menos 10 caracteres')
    return { isValid: errors.length === 0, errors }
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  getProviderInfo() {
    return {
      provider: 'backend',
      backendUrl: this.backendUrl,
      isConfigured: !!this.backendUrl,
    }
  }
}

export default new EmailService()
